import { useHistory } from 'react-router-dom';

import { Button } from '@cobliteam/ui/components';
import queryString from 'query-string';

import { Location, UserPermission } from '@cobliteam/common-types';
import { GeofenceFormat, type PlainGeofence } from '@cobliteam/common-types/src/geofenceV3';

import { ConditionCategory } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/conditions';
import { RuleCategory } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/rules';

import { Analytics } from '@cobliteam/analytics';
import useMonitoringStore from '@cobliteam/monitoring/src/store/useMonitoringStore';

import { DomainTypes } from '@cobliteam/store';

import Icon from '@cobliteam/ui/icons';

import withPermission from '../../../../PermissionsGate/PermissionsGate';

interface GeofencePopupFooterProps {
  geofence?: PlainGeofence;
}

const formatName = {
  [GeofenceFormat.CIRCLE]: 'local',
  [GeofenceFormat.DRAWING]: 'local',
  [GeofenceFormat.RECTANGLE]: 'local',
  default: 'local',
};

const PopupFooter = ({ geofence }: GeofencePopupFooterProps) => {
  const setGeofenceToEdit = useMonitoringStore((state) => state.setGeofenceToEdit);
  const setSelectedTab = useMonitoringStore((state) => state.setSelectedTab);

  const history = useHistory();
  const params = queryString.parse(location.search) as Record<string, string | null>;

  const handleEditGeofence = () => {
    setGeofenceToEdit(geofence);
    setSelectedTab(DomainTypes.GEOFENCE_FORM);

    history.push({
      search: queryString.stringify({
        tab: 'geofences',
        subTab: 'create-update',
      }),
    });
    params.tab = 'geofences';
    params.subTab = 'create-update';
  };

  const handleTriggerHook = () => {
    const params = queryString.stringify({
      templateRule: RuleCategory.GEOFENCE,
      templateCondition: ConditionCategory.GEOFENCE_IN_OUT,
      geofenceId: geofence?.id,
    });

    Analytics.track('Created Geofence Rule by Hook Popup Map');
    history.push(`${Location.TRIGGERS_CREATE}?${params}`);
  };

  return (
    <div className='flex items-center gap-5 px-5 pt-3 pb-5'>
      <Button className='w-full' variant='outlined' size='sm' startIcon={<Icon name='plus' />} onClick={handleTriggerHook}>
        Criar regra
      </Button>
      <Button className='w-full' color='primary' size='sm' startIcon={<Icon name='pencil' />} onClick={handleEditGeofence} data-cy='geofence-popupfooter'>
        {`Editar ${formatName[geofence?.format || 'default']}`}
      </Button>
    </div>
  );
};

export default withPermission(UserPermission.CREATE_UPDATE_DELETE_PLACES_OF_INTEREST, PopupFooter);
